import {Role} from 'src/openapi/models/Role';
import {UserRoles} from 'src/openapi/models/UserRoles';

export const updateUserRole = (
    userRoles: UserRoles,
    role: string,
    checked: boolean,
): UserRoles => {
    const {roles, ...rest} = userRoles;

    const updatedRoles = checked
        ? Array.from(new Set([...roles, role]))
        : roles.filter(userRole => userRole !== role);

    return {
        ...rest,
        roles: updatedRoles as Role[],
    };
};
